var _path, _path2, _path3, _line, _line2, _line3, _line4, _line5, _line6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.25275L18.2691 8.04552V19.6311L14 25.4238L9.73086 19.6311V8.04552L14 2.25275Z",
    fill: "#40B4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4648 2.25275L27.3924 8.04552V19.6311L23.4648 25.4238L19.5372 19.6311V8.04552L23.4648 2.25275Z",
    fill: "#047732"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53521 2.25275L8.46282 8.04552V19.6311L4.53521 25.4238L0.607603 19.6311V8.04552L4.53521 2.25275Z",
    fill: "#FFC526"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.73334,
    x2: 4.73334,
    y2: 6.11459,
    stroke: "#FFC526",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.0667,
    x2: 14.0667,
    y2: 6.11459,
    stroke: "#40B4E5",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 23.4,
    x2: 23.4,
    y2: 6.11459,
    stroke: "#047732",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 23.4,
    y1: 21.8854,
    x2: 23.4,
    y2: 28,
    stroke: "#047732",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14.0667,
    y1: 21.8854,
    x2: 14.0667,
    y2: 28,
    stroke: "#40B4E5",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 4.73334,
    y1: 21.8854,
    x2: 4.73334,
    y2: 28,
    stroke: "#FFC526",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo-header.2180d347a28a747241a26281f2ed5959.svg";
export { ForwardRef as ReactComponent };